// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface SetOnePageCheckoutProductLisOverlayParameter {
    isOpen: boolean;
}

type HandlerType = Handler<SetOnePageCheckoutProductLisOverlayParameter>;

export const DispatchSetOnePageCheckoutProductLisOverlayIsOpen: HandlerType = props => {
    props.dispatch({
        type: "Starter/Components/OnePageCheckoutProductListOverlay/SetOnePageCheckoutProductListOverlayIsOpen",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetOnePageCheckoutProductLisOverlayIsOpen];

const setOnePageCheckoutProductListOverlayIsOpen = createHandlerChainRunner(
    chain,
    "SetOnePageCheckoutProductListOverlayIsOpen",
);
export default setOnePageCheckoutProductListOverlayIsOpen;
